import React from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import WhiteBox from 'components/WhiteBox';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { getSpecialistSuffix } from 'utils/plurals-declination';
import Model from '../../../../model';

import './index.sass';
import Details from 'components/Details';

const { block, el } = bem('front-project');

const Project = () => {

    return (
        <div className={ block() }>
            <WhiteBox>
                <div className={ el('top-block') }>
                    <div className={ el('title') }><Text serif>О проекте</Text></div>
                    <div className={ el('description') }>
                        <Text tag={ 'p' }>
                            <b>Otvet.co</b> — бутиковый сервис по подбору и работе с психологами.
                            Проект был основан в 2017 году практикующим специалистом Вероникой Сидоровой и
                            создавался как платформа, безопасное пространство, где клиенты могут найти своего
                            специалиста и получить качественный сервис.
                        </Text>
                        <Text tag={ 'p' }>
                            За 6 лет существования проекта к нам обратилось более 25 000 клиентов со всего мира —
                            терапевты <b>Otvet.co</b> работают как очно, так и онлайн.
                            Всего вместе с вами мы провели 60 000 консультаций — эта цифра продолжает расти каждый день.
                        </Text>
                        <Details detailsText={ 'Далее' }>
                            <Text tag={ 'p' }>
                                В команде проекта — специалисты, практикующие разные методы: гештальт, классический
                                психоанализ, ACT-терапию и другие направления. Каждый из них — признанный сообществом
                                опытный профессионал, прошедший несколько этапов собеседований. Нам важно, чтобы
                                направления и возможности работы наших специалистов были максимально широкими и
                                соответствовали запросам людей, которые сталкиваются с самыми разными чувствами и
                                ситуациями. Кроме профессиональных компетенций есть и другие, не менее значимые факторы
                                отбора специалистов в команду — это человеческое тепло, мудрость, щедрость души и
                                возможность видеть и показывать другому красоту момента, которая бывает неочевидной.
                            </Text>
                            <Text tag={ 'p' }>
                                <b>Otvet.co</b> сегодня — это не только консультации. Мир проекта растет и предлагает
                                своим клиентам
                                новые способы соприкосновения с важными темами, разные варианты познания и изучения себя.
                                Мы регулярно проводим групповые мастерские в Москве и Санкт-Петербурге,
                                создаем онлайн-продукты — вебинары, курсы, интервью со специалистами и
                                профессионалами сферы. Значимым в развитии проекта стал подкаст <b>Otvet.co</b>,
                                прослушивания которого превысили отметку в 1 миллион и нашли отклик у тысяч людей по
                                всему миру.
                            </Text>
                            <Text tag={ 'p' }>
                                Где бы вы ни были, что бы ни происходило, — мы всегда на вашей стороне.
                            </Text>
                        </Details>
                    </div>
                </div>
                <div className={ el('snippets') }>
                    <Icon tag="div" name={ 'star' } />
                    <Text tag="div">6 лет успешной работы</Text>
                    <Icon tag="div" name={ 'users-three' } />
                    <Text tag="div">{ `${ 60 } ${ getSpecialistSuffix(60) }` }</Text>
                    <Icon tag="div" name={ 'sun-dim' } />
                    <Text tag="div">Удобная и быстрая запись</Text>
                    <Icon tag="div" name={ 'leaf' } />
                    <Text tag="div">Конфиденциальность и безопасность</Text>
                </div>
            </WhiteBox>
        </div>
    );
};

export default observer(Project);
